import { styled } from '@mui/material';

export const ListItem = styled('li')(({ theme }) => ({
  '&::before' : {
    content    : '"\\2022"',
    color      : theme.palette.primary.blue1,
    fontWeight : 'bold',
    display    : 'inline-block',
    width      : '1em',
    marginLeft : '-1em',
  },
}));

export const List = styled('ul')({
  listStyle : 'none',
});
